import { render, staticRenderFns } from "./AppNavMenus.vue?vue&type=template&id=2d2410c2&scoped=true"
import script from "./AppNavMenus.vue?vue&type=script&lang=js"
export * from "./AppNavMenus.vue?vue&type=script&lang=js"
import style0 from "./AppNavMenus.vue?vue&type=style&index=0&id=2d2410c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2410c2",
  null
  
)

export default component.exports